import { createExportReport } from 'shared/ui';
import { ExportReportAccountsModel } from '../../model';

export const createExportReportAccountsButton = (model: ExportReportAccountsModel) => {
	const ExportReport = createExportReport(model);

	return ExportReport;
};
